import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import PolylineIcon from "@mui/icons-material/Polyline";
import { CircularProgress, Tooltip } from "@mui/material";

import { ButtonVariant } from "Constant/button";

import StandartButton from "components/atoms/StandartButton";
import EllipsisText from "components/EllipsisText";
import {
    ActionsCell,
    StatusDotSmall,
    StatusPill,
} from "components/organisms/GenericTable/GenericTable.styled";
import { GenericTableColumn } from "components/organisms/GenericTable/GenericTable.types";

export const createLandingPagesListColumns = ({
    navigate,
    dispatchSetLandingPageDetails,
    onRequestDelete,
    deletingLandingPageId,
}: {
    navigate: (path: string) => void;
    dispatchSetLandingPageDetails: (row: any) => void;
    onRequestDelete: (id: number) => void;
    deletingLandingPageId?: number | null;
}): GenericTableColumn[] => {
    return [
        {
            key: "id",
            header: "ID",
            label: "ID",
            width: 1,
            defaultHidden: true,
            render: (row) => (
                <EllipsisText text={String(row.id)} width="100%" />
            ),
        },
        {
            key: "name",
            header: "Name",
            label: "Name",
            width: 2,
            render: (row) => <EllipsisText text={row.name} width="100%" />,
        },
        {
            key: "url",
            header: "URL",
            label: "URL",
            width: 2.5,
            render: (row) => (
                <EllipsisText
                    text={row?.page_url}
                    href={row?.page_url}
                    width="100%"
                />
            ),
        },

        {
            key: "status",
            header: "Status",
            label: "Status",
            fixedWidth: 150,
            render: (row) => (
                <StatusPill $status={row.is_published ? "healthy" : "idle"}>
                    <StatusDotSmall />
                    {row.is_published ? "Published" : "Draft"}
                </StatusPill>
            ),
        },
        {
            key: "actions",
            header: "",
            label: "Actions",
            align: "right",
            hideable: false,
            fixedWidth: 200,
            render: (row) => {
                const isDeleting = deletingLandingPageId === row.id;
                return (
                    <ActionsCell>
                        <Tooltip title="Open website.">
                            <span>
                                <StandartButton
                                    iconButton
                                    variant={ButtonVariant.BLACK_OUTLINED}
                                    disabled={isDeleting}
                                    onClick={() => {
                                        window.open(row?.page_url);
                                    }}
                                >
                                    <OpenInNewIcon fontSize="small" />
                                </StandartButton>
                            </span>
                        </Tooltip>
                        <Tooltip title="Edit landing page.">
                            <span>
                                <StandartButton
                                    iconButton
                                    variant={ButtonVariant.BLACK_OUTLINED}
                                    disabled={isDeleting}
                                    onClick={() => {
                                        dispatchSetLandingPageDetails(row);
                                        setTimeout(() => {
                                            navigate(
                                                `/landing-pages/edit/${row.id}`,
                                            );
                                        }, 50);
                                    }}
                                >
                                    <EditOutlinedIcon fontSize="small" />
                                </StandartButton>
                            </span>
                        </Tooltip>
                        <Tooltip title="Clone landing page.">
                            <span>
                                <StandartButton
                                    iconButton
                                    variant={ButtonVariant.BLACK_OUTLINED}
                                    disabled={isDeleting}
                                    onClick={() => {
                                        dispatchSetLandingPageDetails(row);
                                        setTimeout(() => {
                                            navigate(`/landing-pages/clone`);
                                        }, 50);
                                    }}
                                >
                                    <PolylineIcon fontSize="small" />
                                </StandartButton>
                            </span>
                        </Tooltip>
                        <Tooltip title="Delete landing page.">
                            <span>
                                <StandartButton
                                    iconButton
                                    variant={ButtonVariant.DANGER_OUTLINED}
                                    disabled={isDeleting}
                                    onClick={() => onRequestDelete(row.id)}
                                >
                                    {isDeleting ? (
                                        <CircularProgress
                                            size={16}
                                            color="inherit"
                                        />
                                    ) : (
                                        <DeleteOutlineIcon fontSize="small" />
                                    )}
                                </StandartButton>
                            </span>
                        </Tooltip>
                    </ActionsCell>
                );
            },
        },
    ];
};
